/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateUserProfile = /* GraphQL */ `
  subscription OnCreateUserProfile(
    $filter: ModelSubscriptionUserProfileFilterInput
    $email: String
  ) {
    onCreateUserProfile(filter: $filter, email: $email) {
      id
      email
      name
      lastName
      idNumber
      phone
      address
      role
      avatarUrl
      enrollments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateUserProfile = /* GraphQL */ `
  subscription OnUpdateUserProfile(
    $filter: ModelSubscriptionUserProfileFilterInput
    $email: String
  ) {
    onUpdateUserProfile(filter: $filter, email: $email) {
      id
      email
      name
      lastName
      idNumber
      phone
      address
      role
      avatarUrl
      enrollments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteUserProfile = /* GraphQL */ `
  subscription OnDeleteUserProfile(
    $filter: ModelSubscriptionUserProfileFilterInput
    $email: String
  ) {
    onDeleteUserProfile(filter: $filter, email: $email) {
      id
      email
      name
      lastName
      idNumber
      phone
      address
      role
      avatarUrl
      enrollments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateBookOrder = /* GraphQL */ `
  subscription OnCreateBookOrder(
    $filter: ModelSubscriptionBookOrderFilterInput
  ) {
    onCreateBookOrder(filter: $filter) {
      id
      bookID
      customerName
      customerEmail
      idNumber
      bankName
      referenceNumber
      bookTitle
      purchaseType
      amountUSD
      amountBS
      receiptKey
      pdfKey
      category
      status
      orderDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateBookOrder = /* GraphQL */ `
  subscription OnUpdateBookOrder(
    $filter: ModelSubscriptionBookOrderFilterInput
  ) {
    onUpdateBookOrder(filter: $filter) {
      id
      bookID
      customerName
      customerEmail
      idNumber
      bankName
      referenceNumber
      bookTitle
      purchaseType
      amountUSD
      amountBS
      receiptKey
      pdfKey
      category
      status
      orderDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteBookOrder = /* GraphQL */ `
  subscription OnDeleteBookOrder(
    $filter: ModelSubscriptionBookOrderFilterInput
  ) {
    onDeleteBookOrder(filter: $filter) {
      id
      bookID
      customerName
      customerEmail
      idNumber
      bankName
      referenceNumber
      bookTitle
      purchaseType
      amountUSD
      amountBS
      receiptKey
      pdfKey
      category
      status
      orderDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateUserNote = /* GraphQL */ `
  subscription OnCreateUserNote(
    $filter: ModelSubscriptionUserNoteFilterInput
    $owner: String
  ) {
    onCreateUserNote(filter: $filter, owner: $owner) {
      id
      bookID
      content
      pageNumber
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateUserNote = /* GraphQL */ `
  subscription OnUpdateUserNote(
    $filter: ModelSubscriptionUserNoteFilterInput
    $owner: String
  ) {
    onUpdateUserNote(filter: $filter, owner: $owner) {
      id
      bookID
      content
      pageNumber
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteUserNote = /* GraphQL */ `
  subscription OnDeleteUserNote(
    $filter: ModelSubscriptionUserNoteFilterInput
    $owner: String
  ) {
    onDeleteUserNote(filter: $filter, owner: $owner) {
      id
      bookID
      content
      pageNumber
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateEnrollment = /* GraphQL */ `
  subscription OnCreateEnrollment(
    $filter: ModelSubscriptionEnrollmentFilterInput
  ) {
    onCreateEnrollment(filter: $filter) {
      id
      userEmail
      courseId
      courseTitle
      amountUSD
      amountBS
      referenceNumber
      bankName
      category
      status
      enrollmentDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateEnrollment = /* GraphQL */ `
  subscription OnUpdateEnrollment(
    $filter: ModelSubscriptionEnrollmentFilterInput
  ) {
    onUpdateEnrollment(filter: $filter) {
      id
      userEmail
      courseId
      courseTitle
      amountUSD
      amountBS
      referenceNumber
      bankName
      category
      status
      enrollmentDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteEnrollment = /* GraphQL */ `
  subscription OnDeleteEnrollment(
    $filter: ModelSubscriptionEnrollmentFilterInput
  ) {
    onDeleteEnrollment(filter: $filter) {
      id
      userEmail
      courseId
      courseTitle
      amountUSD
      amountBS
      referenceNumber
      bankName
      category
      status
      enrollmentDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateDocumentRequest = /* GraphQL */ `
  subscription OnCreateDocumentRequest(
    $filter: ModelSubscriptionDocumentRequestFilterInput
  ) {
    onCreateDocumentRequest(filter: $filter) {
      id
      customerName
      customerEmail
      idNumber
      phone
      areaLegal
      documentType
      description
      clientFileKey
      receiptKey
      resultUrl
      bankName
      priceUSD
      referenceNumber
      category
      status
      requestDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateDocumentRequest = /* GraphQL */ `
  subscription OnUpdateDocumentRequest(
    $filter: ModelSubscriptionDocumentRequestFilterInput
  ) {
    onUpdateDocumentRequest(filter: $filter) {
      id
      customerName
      customerEmail
      idNumber
      phone
      areaLegal
      documentType
      description
      clientFileKey
      receiptKey
      resultUrl
      bankName
      priceUSD
      referenceNumber
      category
      status
      requestDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteDocumentRequest = /* GraphQL */ `
  subscription OnDeleteDocumentRequest(
    $filter: ModelSubscriptionDocumentRequestFilterInput
  ) {
    onDeleteDocumentRequest(filter: $filter) {
      id
      customerName
      customerEmail
      idNumber
      phone
      areaLegal
      documentType
      description
      clientFileKey
      receiptKey
      resultUrl
      bankName
      priceUSD
      referenceNumber
      category
      status
      requestDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateNotification = /* GraphQL */ `
  subscription OnCreateNotification(
    $filter: ModelSubscriptionNotificationFilterInput
    $recipientEmail: String
  ) {
    onCreateNotification(filter: $filter, recipientEmail: $recipientEmail) {
      id
      recipientEmail
      title
      message
      type
      isRead
      relatedId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateNotification = /* GraphQL */ `
  subscription OnUpdateNotification(
    $filter: ModelSubscriptionNotificationFilterInput
    $recipientEmail: String
  ) {
    onUpdateNotification(filter: $filter, recipientEmail: $recipientEmail) {
      id
      recipientEmail
      title
      message
      type
      isRead
      relatedId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteNotification = /* GraphQL */ `
  subscription OnDeleteNotification(
    $filter: ModelSubscriptionNotificationFilterInput
    $recipientEmail: String
  ) {
    onDeleteNotification(filter: $filter, recipientEmail: $recipientEmail) {
      id
      recipientEmail
      title
      message
      type
      isRead
      relatedId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateExchangeRate = /* GraphQL */ `
  subscription OnCreateExchangeRate(
    $filter: ModelSubscriptionExchangeRateFilterInput
  ) {
    onCreateExchangeRate(filter: $filter) {
      id
      currency
      value
      lastUpdated
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateExchangeRate = /* GraphQL */ `
  subscription OnUpdateExchangeRate(
    $filter: ModelSubscriptionExchangeRateFilterInput
  ) {
    onUpdateExchangeRate(filter: $filter) {
      id
      currency
      value
      lastUpdated
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteExchangeRate = /* GraphQL */ `
  subscription OnDeleteExchangeRate(
    $filter: ModelSubscriptionExchangeRateFilterInput
  ) {
    onDeleteExchangeRate(filter: $filter) {
      id
      currency
      value
      lastUpdated
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateCourse = /* GraphQL */ `
  subscription OnCreateCourse($filter: ModelSubscriptionCourseFilterInput) {
    onCreateCourse(filter: $filter) {
      id
      title
      subtitle
      description
      targetAudience
      learningObjectives
      modulesText
      evaluationsText
      duration
      startDate
      priceUSD
      instructor
      thumbnailUrl
      promoVideoUrl
      images
      videos
      category
      status
      lessons {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateCourse = /* GraphQL */ `
  subscription OnUpdateCourse($filter: ModelSubscriptionCourseFilterInput) {
    onUpdateCourse(filter: $filter) {
      id
      title
      subtitle
      description
      targetAudience
      learningObjectives
      modulesText
      evaluationsText
      duration
      startDate
      priceUSD
      instructor
      thumbnailUrl
      promoVideoUrl
      images
      videos
      category
      status
      lessons {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteCourse = /* GraphQL */ `
  subscription OnDeleteCourse($filter: ModelSubscriptionCourseFilterInput) {
    onDeleteCourse(filter: $filter) {
      id
      title
      subtitle
      description
      targetAudience
      learningObjectives
      modulesText
      evaluationsText
      duration
      startDate
      priceUSD
      instructor
      thumbnailUrl
      promoVideoUrl
      images
      videos
      category
      status
      lessons {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateLesson = /* GraphQL */ `
  subscription OnCreateLesson($filter: ModelSubscriptionLessonFilterInput) {
    onCreateLesson(filter: $filter) {
      id
      courseID
      title
      videoUrl
      duration
      order
      description
      content
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateLesson = /* GraphQL */ `
  subscription OnUpdateLesson($filter: ModelSubscriptionLessonFilterInput) {
    onUpdateLesson(filter: $filter) {
      id
      courseID
      title
      videoUrl
      duration
      order
      description
      content
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteLesson = /* GraphQL */ `
  subscription OnDeleteLesson($filter: ModelSubscriptionLessonFilterInput) {
    onDeleteLesson(filter: $filter) {
      id
      courseID
      title
      videoUrl
      duration
      order
      description
      content
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateBook = /* GraphQL */ `
  subscription OnCreateBook($filter: ModelSubscriptionBookFilterInput) {
    onCreateBook(filter: $filter) {
      id
      title
      author
      description
      priceUSD
      pricePhysical
      pricePDF
      priceOnline
      imageKey
      images
      videos
      pdfKey
      hasPhysical
      hasDigital
      hasOnline
      category
      s3FolderName
      imagePrefix
      onlineExtension
      totalPages
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateBook = /* GraphQL */ `
  subscription OnUpdateBook($filter: ModelSubscriptionBookFilterInput) {
    onUpdateBook(filter: $filter) {
      id
      title
      author
      description
      priceUSD
      pricePhysical
      pricePDF
      priceOnline
      imageKey
      images
      videos
      pdfKey
      hasPhysical
      hasDigital
      hasOnline
      category
      s3FolderName
      imagePrefix
      onlineExtension
      totalPages
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteBook = /* GraphQL */ `
  subscription OnDeleteBook($filter: ModelSubscriptionBookFilterInput) {
    onDeleteBook(filter: $filter) {
      id
      title
      author
      description
      priceUSD
      pricePhysical
      pricePDF
      priceOnline
      imageKey
      images
      videos
      pdfKey
      hasPhysical
      hasDigital
      hasOnline
      category
      s3FolderName
      imagePrefix
      onlineExtension
      totalPages
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateBannerAd = /* GraphQL */ `
  subscription OnCreateBannerAd($filter: ModelSubscriptionBannerAdFilterInput) {
    onCreateBannerAd(filter: $filter) {
      id
      title
      imageUrl
      targetUrl
      position
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateBannerAd = /* GraphQL */ `
  subscription OnUpdateBannerAd($filter: ModelSubscriptionBannerAdFilterInput) {
    onUpdateBannerAd(filter: $filter) {
      id
      title
      imageUrl
      targetUrl
      position
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteBannerAd = /* GraphQL */ `
  subscription OnDeleteBannerAd($filter: ModelSubscriptionBannerAdFilterInput) {
    onDeleteBannerAd(filter: $filter) {
      id
      title
      imageUrl
      targetUrl
      position
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
